import React, {Component} from 'react';
import './styles/styles.css';
import {firebase} from '../../../firebase';

import Item from './components/Item';
class ItemBlogSmall extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      error: false,
      News: [],
    };
  }
  componentDidMount() {
    const docRef = firebase
      .firestore()
      .collection('news')
      .orderBy('position', 'asc');

    docRef
      .get()
      .then(querySnapshot => {
        const News = [];
        querySnapshot.forEach(doc => {
          const {tittle, position, content, image, date} = doc.data();
          News.push({
            id: doc.id,
            tittle,
            position,
            content,
            image,
            date,
          });
        });

        if (News.length) {
          this.setState(() => ({loading: false, News, error: false}));
        } else {
          this.setState(() => ({loading: false, error: true}));
        }
      })
      .catch(error => {
        this.setState({error: true, loading: false});
      });
  }
  render() {
    return (
      <>
        {this.state.News.map(item => (
          <Item new={item} />
        ))}
      </>
    );
  }
}

export default ItemBlogSmall;
